export default "__VITE_ASSET__UfBlOVcL__"